/* eslint-disable import/order */
/*
=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
*/

import Vue from 'vue';
import 'jquery';
import 'bootstrap';
import App from './App';

import './filters/filters';

import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css';
import 'vuesax/dist/vuesax.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import VueTheMask from 'vue-the-mask';
// Febos Config
// import febosConfig from './febos/servicios/febosConfig.js'
// axios
import clientApi from './febos/servicios/clienteFebosAPI';

// Theme Configurations
import '../themeConfig';

// Globally Registered Components
import './globalComponents';

// Date Time
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

// Styles: SCSS
import './assets/scss/vuexy/main.scss';
import './assets/scss/main.scss';
import './assets/scss/multiSelect.scss';
import './assets/css/treeView.css';
import '@core/assets/fonts/feather/iconfont.css'; // For form-wizard
import '@core/scss/core.scss';
import '@/assets/scss/style.scss';
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// Vuex Store
import store from './store/store';
// import { sync } from 'vuex-router-sync'

// sync(store, router)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';

// idle
import IdleVue from 'idle-vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css';

import VeeValidate from 'vee-validate';
import spanish from 'vee-validate/dist/locale/es';
import Ripple from 'vue-ripple-directive';

import './shame';

import VTooltip from 'v-tooltip';

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import VoerroTagsInput from '@voerro/vue-tagsinput';
import '../node_modules/@voerro/vue-tagsinput/dist/style.css';

Vue.component('tags-input', VoerroTagsInput);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.use(VueTheMask);
Vue.use(CKEditor);

Vue.use(Vuesax);
Vue.use(require('vue-moment'));

Vue.directive('ripple', Ripple);

Vue.use(VTooltip);

Vue.moment.locale('es', {
  months: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
  monthsShort: ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'],
  monthsParseExact: true,
  weekdays: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sabado'],
  weekdaysShort: ['dom.', 'lun.', 'mar.', 'mie.', 'jue.', 'vie.', 'sab.'],
  weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    LLL: 'D [de] MMMM [de] YYYY H:mm',
    LLLL: 'DD-MM-YYYY [a] [las] H:mm [hrs]'
  },
  calendar: {
    sameDay() {
      return `[hoy a la${(this.hours() !== 1) ? 's' : ''}] LT`;
    },
    nextDay() {
      return `[mañana a la${(this.hours() !== 1) ? 's' : ''}] LT`;
    },
    nextWeek() {
      return `dddd [a la${(this.hours() !== 1) ? 's' : ''}] LT`;
    },
    lastDay() {
      return `[ayer a la${(this.hours() !== 1) ? 's' : ''}] LT`;
    },
    lastWeek() {
      return `[el] dddd [pasado a la${(this.hours() !== 1) ? 's' : ''}] LT`;
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: 'en %s',
    past: 'hace %s',
    s: 'unos segundos',
    m: 'un minuto',
    mm: '%d minutos',
    h: 'una hora',
    hh: '%d horas',
    d: 'un día',
    dd: '%d días',
    M: 'un mes',
    MM: '%d meses',
    y: 'un año',
    yy: '%d años'
  },
  ordinalParse: /\d{1,2}º/,
  ordinal: '%dº',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});

Vue.prototype.$http = clientApi;

Vue.component('datetime', Datetime);

Vue.use(VueHammer);

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: process.env.VUE_APP_AMBIENTE === 'desarrollo'
    ? 1000 * 60 * 480 // 8 hrs
    : 1000 * 60 * 15, // 15 minutos
  startAtIdle: false
});

// Feather font icon
require('./assets/css/iconfont.css');
// color icons for files
require('./assets/css/iconcolors.css');

Vue.use(VeeValidate, {
  fieldsBagName: 'formFields',
  locale: 'es',
  dictionary: {
    es: {
      messages: spanish.messages,
      attributes: {
        companyIut: 'rut empresa',
        razonSocial: 'razón social',
        responsibleIut: 'rut',
        responsibleName: 'nombre',
        responsibleEmail: 'correo',
        amount: 'monto',
        selectedUserId: 'usuario',
        name: 'nombre',
        description: 'descripción',
        request: 'solicitud',
        certificatePassword: 'contraseña de certificado',
        documentType: 'tipo de documento',
        document: 'documento',
        matter: 'materia',
        institutionType: 'tipo de institución',
        subjectType: 'para el tipo de destino',
        subject: 'para el destinatario',
        subjectTypeDigitalDoc: 'lista de instituciones',
        subjectEmail: 'correo',
        copySubjectType: 'para el tipo de distribución',
        copySubject: 'para la copia',
        copySubjectTypeDigitalDoc: 'lista de instituciones',
        copySubjectEmail: 'correo',
        personName: 'persona',
        personId: 'nombre',
        directionId: 'dirección',
        documentDetail: 'detalle',
        mainFileName: 'documento principal',
        relatedDocumentType: 'relacionado con',
        relatedDocumentNumber: 'nº de documento',
        stepType: 'tipo de paso',
        rolType: 'tipo de rol',
        userStep: 'usuario',
        groupStep: 'grupo',
        personEmail: 'correo de persona',
        creatorGroup: 'grupo asociado a expediente',
        approach: 'alcance',
        renew: 'reinicio',
        initialSheet: 'folio inicial',
        configId: 'elemento grupo',
        configIdUser: 'elemento usuario',
        configFolio: 'folio inicial',
        comment: 'comentario',
        otpCode: 'otp',
        otp: 'otp',
        user: 'usuario',
        resendSubject: 'usuario a reenviar',
        numeration: 'folio',
        groupCode: 'código',
        groupName: 'nombre de grupo',
        groupDescription: 'descripción de grupo',
        address: 'dirección',
        iutNumber: 'número documento',
        email: 'correo',
        landline: 'teléfono fijo',
        phone: 'teléfono móvil',
        civilStatus: 'estado civil',
        birthday: 'fecha de nacimiento',
        targetUser: 'usuario',
        code: 'código',
        serialNumber: 'número de serie del documento',
        commune: 'comuna de residencia'
      }
    }
  }
});

const { Validator } = VeeValidate;
Validator.extend('email', {
  getMessage: (field) => `El campo ${field} no es un correo electrónico válido`,
  validate(value) {
    if (!/^[\x20-\x7E]+$/.test(value)) return false;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
  },
});

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
/* let archivoPackage=require('../package.json');
console.log('config',archivoPackage);
process.env.VUE_APP_VERSION = archivoPackage.version;
console.log('VERSION: ',process.env.VUE_APP_VERSION)
*/
Vue.config.productionTip = false;

// Temporal: identifica el componente que valida un campo desmontado
Vue.config.errorHandler = (err, vm, info) => {
  if (
    err
    && err.message
    && err.message.includes('Validating a non-existent field')
  ) {
    console.warn(
      '[vv-debug]',
      err.message,
      '\nComponente:', vm && vm.$options.name,
      '\nArchivo:', vm && vm.$options.__file,
      '\nInfo:', info
    );
    return;
  }
  console.error(err);
};
Vue.prototype.$log = {
  debug(...args) {
    const now = new Date().toLocaleTimeString();
    if (localStorage.getItem('logLevel') === 'debug'
    ) {
      console.warn(now, '[debug]', ...args);
    }
  },
  info(...args) {
    const now = new Date().toLocaleTimeString();
    if (localStorage.getItem('logLevel') === 'debug'
      || localStorage.getItem('logLevel') === 'info'
    ) {
      console.log(now, '[info]', ...args);
    }
  },
  error(...args) {
    const now = new Date().toLocaleTimeString();
    if (localStorage.getItem('logLevel') === 'debug'
      || localStorage.getItem('logLevel') === 'info'
      || localStorage.getItem('logLevel') === 'error'
    ) {
      console.error(now, '[error]', ...args);
    }
  }
};

export const app = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
